
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { GenericHttpService } from '../generic-http.service';
import { ParametrosService } from './parametros.service';
import { ConfiguracoesProjeto } from '../index';
import { DemonstrativoImpostoRenda } from '../model/demonstrativo-imposto-renda.model';
import { Observable } from 'rxjs';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { GerenciamentoFilename } from '../arquivo/filename-gerenciamento';
import { FiltroDemonstrativoImpostoRenda } from '../filter/filtro-demonstrativo-imposto-renda';
import { LoadingService } from '../../shared-layout/loading/loading.service';

@Injectable()
export class DemonstrativoImpostoRendaService {

    public configuracao: ConfiguracoesProjeto;
    public _urlBase: string;
    public demostrativoChange = new Subject<DemonstrativoImpostoRenda[]>();

    constructor(private readonly demonstrativoHttpService: GenericHttpService<DemonstrativoImpostoRenda>,        
                private readonly parametrosService: ParametrosService,
                private readonly http: Http,
                private readonly loadingService: LoadingService ) { }

    public get urlBase() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri  + 'imposto-renda-cidadao';
        return this._urlBase;
    }

    public obterDemostrativos(idConsumidor: number) {
        const s: Subscription = this.demonstrativoHttpService.getAll(`${this.urlBase}/listagem-imposto-renda-contemplado/${idConsumidor}`)
            .subscribe(
                (data: Array<DemonstrativoImpostoRenda>) => {
                    this.demostrativoChange.next(data.slice());
                },
                (error: any) => {
                    this.demostrativoChange.next([]);
                },
                () => {
                    s.unsubscribe();
                }

            );
    }

    public downloadArquivoDemonstrativo(idConsumidor: number, anoCalendario: number) {

        const url = this.urlBase.concat(`/arquivo`);
        const requestOptions = new RequestOptions({ headers : this.getHeaders(), responseType : ResponseContentType.Blob});
    
        this.loadingService.exibirLoading(null);
        
        let filtro = new FiltroDemonstrativoImpostoRenda(idConsumidor, anoCalendario);
    
        return this.http        
          .post(url, filtro, requestOptions)
          .map(
            (res) => {
    
                this.loadingService.esconderLoading();
    
            return {
              filename: GerenciamentoFilename.ObterBasicFileName(res),
              data: res.blob()
            };
          })
          .catch(this.handleError);
        }

        public handleError = (error: Response) => {
            this.loadingService.esconderLoading();           
            return Observable.throw(error.json());
        };

        private getHeaders(): Headers {
            
            const headers = new Headers();
            headers.append('Authorization', 'Bearer '  + localStorage.getItem("authorizationData"));
            headers.append('Accept', 'application/pdf, application/json, */*');
            headers.append('Npb', 'true');
            headers.append('responseType', 'blob');
            headers.append('observe', 'response');            
            return headers;
        }

}


// WEBPACK FOOTER //
// ./src/app/shared/service/demonstrativo-imposto-renda.service.ts